// src/firebase/config.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyAcpiY6_h_gm0UGOMAXTqrmLobjAMwaXck",
    authDomain: "litvill-assignments.firebaseapp.com",
    projectId: "litvill-assignments",
    storageBucket: "litvill-assignments.firebasestorage.app",
    messagingSenderId: "1075708119684",
    appId: "1:1075708119684:web:bd03d364d840fc1f1850d1",
    measurementId: "G-K6RK2V12XE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const db = getFirestore(app);
const auth = getAuth(app);

// Don't initialize storage - export null to prevent crashes
const storage = null;

export { app, db, auth, storage };